// 🔒
const bootyAndCoreBuilder = new URL("../assets/booty-and-core-builder.webp", import.meta.url).href;
const funkcionalniBodybuilding = new URL("../assets/funkcionalni-bodybuilding.webp", import.meta.url).href;
const proBuilder = new URL("../assets/pro-builder.webp", import.meta.url).href;
const fitAndFaboulusUnstopable = new URL("../assets/fit-and-faboulus-unstopable.webp", import.meta.url).href;
const tinaFitCookbook = new URL("../assets/tina-fit-cookbook.webp", import.meta.url).href;
const tinaHyroxStart = new URL("../assets/tina-hyrox-start.webp", import.meta.url).href;
const matejBeginnerBuilder = new URL("../assets/matej-beginner-builder.webp", import.meta.url).href;
const matejBootyBuilder = new URL("../assets/matej-booty-builder.webp", import.meta.url).href;
const matejHiit = new URL("../assets/matej-hiit.webp", import.meta.url).href;
const jurijArmsAndShoulders = new URL("../assets/jurij-arms-and-shoulders.webp", import.meta.url).href;
const jurijBeginnerStrength = new URL("../assets/jurij-beginner-strength.webp", import.meta.url).href;
const jurijMobilityAndStretching = new URL("../assets/jurij-mobility-and-stretching.webp", import.meta.url).href;
const igorFitAndFabulousElevated = new URL("../assets/igor-fit-and-fabulous-elevated.webp", import.meta.url).href;
const igorFitAndFabulousGentleStart = new URL("../assets/igor-fit-and-fabulous-gentle-start.webp", import.meta.url).href;
const katrinPilatesIntermediate = new URL("../assets/katrin-pilates-intermediate.webp", import.meta.url).href;
const katrinRunnersKneeRehab = new URL("../assets/katrin-runners-knee-rehab.webp", import.meta.url).href;
const lukaSquatProgram = new URL("../assets/luka-squat-program.webp", import.meta.url).href;
const lukaTipsAndTricks = new URL("../assets/luka-tips-and-tricks.webp", import.meta.url).href;

export const programs = [
  {
    id: 1,
    trainerSlugs: ["tina-pecaver"],
    title: "Booty & Core Builder",
    category: "Muscle Gain",
    level: "All Levels",
    description: "An 8-week program built to help you develop stronger, more sculpted glutes and a powerful core. Grounded in progressive strength training principles, it's ideal for female beginners and intermediate lifters seeking structured, effective workouts that deliver real, lasting results.",
    image: bootyAndCoreBuilder,
    featured: true
  },
  {
    id: 2,
    trainerSlugs: ["tina-pecaver"],
    title: "Fit Cookbook",
    category: "Nutrition",
    level: "All Levels",
    description: "A complete digital cookbook packed with simple, balanced, nutrient-rich recipes for every part of your day, from energizing breakfasts to quick on-the-go snacks. Each recipe supports your goals, whether that's fat loss or muscle gain, with practical tips for stress-free meal planning.",
    image: tinaFitCookbook
  },
  {
    id: 3,
    trainerSlugs: ["tina-pecaver"],
    title: "Hyrox Start",
    category: "Hyrox",
    level: "Beginner",
    description: "An 8-week preparation program for Hyrox competition. It builds your aerobic base, strength endurance, and the ability to transition smoothly between cardio and functional stations, ideal for recreational athletes and first-timers gearing up for their first Hyrox race.",
    image: tinaHyroxStart
  },
  {
    id: 4,
    trainerSlugs: ["matej-krestic"],
    title: "Beginner Builder",
    category: "Muscle Gain",
    level: "Beginner",
    description: "An 8-week program for lifters just starting out. Instead of random exercises, you get a clear structure split across key muscle groups — chest & biceps, back & triceps, and leg day — teaching proper movement, stability, and safe progressive overload so your results actually last.",
    image: matejBeginnerBuilder
  },
  {
    id: 5,
    trainerSlugs: ["matej-krestic"],
    title: "Booty Builder",
    category: "Muscle Gain",
    level: "All Levels",
    description: "Built for maximum glute activation and firmer legs through science-backed movement patterns. Using hip thrusts, RDLs, and hack squats, the focus is on biomechanics and mind-muscle control rather than just lifting heavy, with systematic progression for real, visible results.",
    image: matejBootyBuilder
  },
  {
    id: 6,
    trainerSlugs: ["matej-krestic"],
    title: "HIIT",
    category: "Fat Loss",
    level: "All Levels",
    description: "A high-intensity program built to push your conditioning to the next level. Dynamic circuits combine full-body strength moves with cardio intervals on rope and ski erg, using minimal rest to maximize calorie burn during the workout and long after it's over.",
    image: matejHiit
  },
  {
    id: 7,
    trainerSlugs: ["matej-krestic"],
    title: "Pro Builder",
    category: "Muscle Gain",
    level: "Advanced",
    description: "Built for those ready to take their physique to the next level. PRO Builder is a systematic approach to muscle sculpting where every rep has a purpose. A smart 5-day split, rooted in deep knowledge of muscle adaptation, ensures optimal training volume for every major muscle group.",
    image: proBuilder,
    featured: true
  },
  {
    id: 8,
    trainerSlugs: ["jurij-spanja"],
    title: "Arms & Shoulders",
    category: "Muscle Gain",
    level: "Intermediate",
    description: "A classic 2-day split built purely for arms and shoulders, designed for lifters chasing that satisfying pump. These are the exact sessions used week after week — simple, focused, and effective. As always, technique comes before the weight on the bar.",
    image: jurijArmsAndShoulders,
    featured: true
  },
  {
    id: 9,
    trainerSlugs: ["jurij-spanja"],
    title: "Beginner Strength",
    category: "Strength",
    level: "Beginner",
    description: "Perfect for anyone completely new to the gym. You'll learn the fundamental movement patterns and build a real training base, progressing week by week at your own pace since you control the load from day one. Technique always comes before the weight you lift.",
    image: jurijBeginnerStrength
  },
  {
    id: 10,
    trainerSlugs: ["jurij-spanja"],
    title: "Funkcionalni Bodybuilding",
    category: "Strength",
    level: "Intermediate",
    description: "A full-body program for experienced lifters ready to test their limits. The exercises are complex and demanding — each session is designed to challenge you while remaining achievable. Expect to be pushed, and remember the golden rule that never changes: always prioritize technique over the weight on the bar.",
    image: funkcionalniBodybuilding
  },
  {
    id: 11,
    trainerSlugs: ["jurij-spanja"],
    title: "Mobility & Stretching",
    category: "Mobility",
    level: "All Levels",
    description: "A go-to collection of mobility drills for the days you don't feel like a full workout but still want to move. Use them before or after any session to stay loose and lower your injury risk. The exercises aren't especially demanding — just spend more time where you feel the most restricted.",
    image: jurijMobilityAndStretching
  },
  {
    id: 12,
    trainerSlugs: ["igor-martic"],
    title: "Fit & Fabulous: Gentle Start",
    category: "Muscle Gain",
    level: "Beginner",
    description: "A slow but intentional starting point, like your very first step into training. Built for women short on time who need a clear plan, this program helps you build strength and confidence at a manageable pace, without the stress.",
    image: igorFitAndFabulousGentleStart
  },
  {
    id: 13,
    trainerSlugs: ["igor-martic"],
    title: "Fit & Fabulous: Elevated",
    category: "Muscle Gain",
    level: "Intermediate",
    description: "Time to take the next step. Built for women who already know the basics and are ready for a real challenge, this program focuses on strength, body shaping, and energy, all through structured, efficient training that adapts to your pace.",
    image: igorFitAndFabulousElevated,
    featured: true
  },
  {
    id: 14,
    trainerSlugs: ["igor-martic"],
    title: "Fit & Fabulous: Unstoppable",
    category: "Muscle Gain",
    level: "Advanced",
    description: "A program crafted for women who are ready to push beyond their limits. Advanced training protocols sculpt your physique, build serious strength, and leave you feeling completely unstoppable. Every session is designed to challenge and inspire — elevating not just your body, but your confidence and energy too.",
    image: fitAndFaboulusUnstopable
  },
  {
    id: 15,
    trainerSlugs: ["katrin-don"],
    title: "Pilates Intermediate",
    category: "Pilates",
    level: "Intermediate",
    description: "For those who already know the basics and are ready to build real strength, stability, and control. The exercises are more dynamic and demanding, with a stronger focus on the connection between body and movement.",
    image: katrinPilatesIntermediate,
    featured: true
  },
  {
    id: 16,
    trainerSlugs: ["katrin-don"],
    title: "Runner's Knee Rehab",
    category: "Rehab",
    level: "All Levels",
    description: "A rehabilitation program for patellofemoral pain syndrome, better known as runner's knee, built on progressive loading and improved neuromuscular control. The goal is less pain, a more stable knee, and a safe, steady return to daily life and sport.",
    image: katrinRunnersKneeRehab
  },
  {
    id: 17,
    trainerSlugs: ["luka-golob"],
    title: "Squat Program",
    category: "Muscle Gain",
    level: "All Levels",
    description: "An 8-week program built entirely around one goal: a stronger, more confident squat. Structured progressive overload helps you build real leg and core strength while cleaning up your technique, suitable for every training level.",
    image: lukaSquatProgram
  },
  {
    id: 18,
    trainerSlugs: ["luka-golob"],
    title: "Tips & Tricks",
    category: "Education",
    level: "All Levels",
    description: "A collection of coaching cues, technique breakdowns, and practical tips gathered from real training sessions. Perfect for cleaning up your form, avoiding common mistakes, and getting more out of every workout, whatever program you're following.",
    image: lukaTipsAndTricks,
    featured: true
  },
  // ---------------------------------------------------------------------------
  // NEW PROGRAMS (19–22) — COMMENTED OUT until their content is ready, so no
  // empty cards show on the deployed site for the testers. Their Stripe payment
  // links already exist in src/data/stripeLinks.js and start working the moment
  // you re-enable a program here.
  // To enable one: uncomment its object below (keep it inside the array), fill
  // the TODO fields, and set a real image (drop a .webp into src/assets, import
  // it at the top of this file, then use image: yourImportedName).
  // ---------------------------------------------------------------------------
  /*
  {
    id: 19,
    trainerSlugs: ["tina-pecaver"],
    title: "TODO", // HIIT (Tina) — Stripe prod_ULFxQR3OevnL0d
    category: "TODO",
    level: "TODO",
    description: "TODO",
    image: null // TODO: add image
  },
  {
    id: 20,
    trainerSlugs: ["katrin-don"],
    title: "TODO", // Fitnes za začetnike (Katrin) — Stripe prod_ULG15SVILlAoy2
    category: "TODO",
    level: "TODO",
    description: "TODO",
    image: null // TODO: add image
  },
  {
    id: 21,
    trainerSlugs: ["luka-golob"],
    title: "TODO", // Hyrox (Luka) — Stripe prod_ULFqWW9bN4aDDp
    category: "TODO",
    level: "TODO",
    description: "TODO",
    image: null // TODO: add image
  },
  {
    id: 22,
    trainerSlugs: ["luka-golob"],
    title: "TODO", // Crossfit (Luka) — Stripe prod_ULFpYdGHBAc9YL
    category: "TODO",
    level: "TODO",
    description: "TODO",
    image: null // TODO: add image
  }
  */
];
// 🔒
